var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { "label-width": "100px", model: _vm.rules, rules: _vm.rule },
        },
        [
          !_vm.formInfo.edit
            ? _c("div", { staticClass: "from-item-title mb15" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("setting.info.essentialinformation"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-box" }, [
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "category_id" } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("合同分类:"),
                    ]),
                    _vm._v(" "),
                    _c("el-cascader", {
                      ref: "myCascader",
                      attrs: {
                        size: "small",
                        options: _vm.options,
                        props: {
                          checkStrictly: true,
                          label: "name",
                          value: "id",
                        },
                        clearable: "",
                      },
                      on: { change: _vm.categoryType },
                      model: {
                        value: _vm.rules.category_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "category_id", $$v)
                        },
                        expression: "rules.category_id",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "title" } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("customer.contractname")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: _vm.$t("customer.placeholder26"),
                      },
                      model: {
                        value: _vm.rules.title,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.rules,
                            "title",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "rules.title",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "price" } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("customer.contractpay")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        size: "small",
                        min: 0,
                        precision: 2,
                        placeholder: _vm.$t("customer.placeholder28"),
                      },
                      model: {
                        value: _vm.rules.price,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.rules,
                            "price",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "rules.price",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "eid" } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("客户名称:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: true, size: "small" },
                        on: { change: _vm.categoryName },
                        model: {
                          value: _vm.rules.eid,
                          callback: function ($$v) {
                            _vm.$set(_vm.rules, "eid", $$v)
                          },
                          expression: "rules.eid",
                        },
                      },
                      _vm._l(_vm.nameList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            disabled: _vm.formInfo.edit ? true : false,
                            label: item.name,
                            value: item.id,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "startTime" } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("toptable.startdate")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      attrs: {
                        size: "small",
                        "picker-options": _vm.startDatePicker,
                        type: "date",
                        clearable: "",
                        format: "yyyy/MM/dd",
                        placeholder: _vm.$t("customer.placeholder29"),
                      },
                      model: {
                        value: _vm.rules.startTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "startTime", $$v)
                        },
                        expression: "rules.startTime",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("toptable.endingdate")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      attrs: {
                        size: "small",
                        type: "date",
                        format: "yyyy/MM/dd",
                        clearable: "",
                        placeholder: _vm.$t("customer.placeholder30"),
                      },
                      model: {
                        value: _vm.rules.endTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "endTime", $$v)
                        },
                        expression: "rules.endTime",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "sign_status" } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("签约状态:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.rules.sign_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.rules, "sign_status", $$v)
                          },
                          expression: "rules.sign_status",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("未签约"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("已签约"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("作废"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("\n            合同编号:\n          "),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        placeholder: "请输入合同编号/订单号",
                      },
                      model: {
                        value: _vm.rules.contract_no,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "contract_no", $$v)
                        },
                        expression: "rules.contract_no",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-form-item",
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("合同状态:"),
                    ]),
                    _vm._v(" "),
                    _c("el-switch", {
                      attrs: {
                        "active-text": "异常",
                        "inactive-text": "正常",
                        "active-value": 1,
                        "inactive-value": 0,
                        "inactive-color": "#1890FF",
                        "active-color": "#C0C4CC",
                      },
                      model: {
                        value: _vm.rules.is_abnormal,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "is_abnormal", $$v)
                        },
                        expression: "rules.is_abnormal",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-box" }, [
            _c(
              "div",
              { staticClass: "form-item width100" },
              [
                _c(
                  "el-form-item",
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(_vm.$t("public.remarks")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        maxlength: "255",
                        "show-word-limit": "",
                        autosize: _vm.autosize,
                        placeholder: _vm.$t("customer.placeholder18"),
                      },
                      model: {
                        value: _vm.rules.mark,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "mark", $$v)
                        },
                        expression: "rules.mark",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }